import links from "@/links/links";

export default {
  actions: {
    FETCH_BY_MEETING(meetingId) {
      return this.get(links.MEETING_CORRESPONDENCE_VOTE_GET_BY_MEETING(meetingId), {
        dataKey: "hydra:member",
      });
    },
    GET(id) {
      return this.get(links.MEETING_CORRESPONDENCE_VOTE_GET(id));
    },
    POST(item) {
      return this.post(links.MEETING_CORRESPONDENCE_VOTE_POST(), item);
    },
    PUT(item) {
      return this.put(links.MEETING_CORRESPONDENCE_VOTE_PUT(item.id), item);
    },
    DELETE(item) {
      return this.delete(links.MEETING_CORRESPONDENCE_VOTE_DELETE(item.id), {
        delete: item.id,
      });
    },
  },
};
